if (!customElements.get('product-component')) {
  customElements.define(
    'product-component',
    class ProductComponent extends HTMLElement {
      connectedCallback() {
        this.cardWrapper = this.querySelector('.card-wrapper');
        if (!this.cardWrapper) return;

        this.cardLink = this.querySelector('.card__heading a, a.full-unstyled-link');
        if (!this.cardLink) return;

        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        if (event.target.closest('a, button, input, label, select, textarea, modal-opener, quick-add-modal, quantity-popover')) {
          return;
        }

        this.cardLink.click();
      }
    }
  );
}
